const Banner = ({ contenidoBanner: { titulo, texto, imagen } }) => {
  return (
    <div
      className="banner__main container-fluid customMargin"
      style={{
        backgroundImage: `url(${imagen})`,
      }}
    >
      <div className="row">
        <div className="banner__container text-center">
          <h2 className="banner__title">{titulo}</h2>
          <p className="banner__text px-2">{texto}</p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
